module.exports = __webpack_public_path__ + "media/images/icon/icons8-Language-5cb8c84ba14881619ee58c1682e6463d.png";